import Link from "next/link";
import React from "react";
import { useRouter } from "next/router";
import styled from "styled-components";
import { useBannerQuery } from "@hook/useBannerQuery";

const MenuWrapper = styled.div`
  display: flex;
  width: 100%;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  padding: 30px 40px;
  align-items: center;
  gap: 35px;
`;

const LeftMenu = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 68px;
  border-right: 1px solid #e0e0e0;
  padding-right: 40px;
`;

const Title = styled.p`
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1db66d;
`;

const MenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const MenuItem = styled.li`
  margin-bottom: 8px;
  font-size: 16px;
  line-height: 1.4;

  a {
    color: #666;
    text-decoration: none;

    &:hover {
      color: #3bb77e;
    }

    &.active {
      font-weight: 800;
      color: #3bb77e;
    }
  }
`;

const BannerArea = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 610px;
    height: auto;
  }
`;

const CategoryMenu = ({ page, title, img, url }) => {
  const router = useRouter();

  return (
    <MenuWrapper>
      <LeftMenu hasBanner={!img}>
        <Title>{title}</Title>
        <MenuList>
          {page.sub.map((subItem, subIdx) => (
            <MenuItem key={subIdx}>
              <Link href={subItem.url || "#"}>
                <a
                  className={router.pathname === subItem.url ? "active" : ""}
                  style={{
                    fontWeight: "100",
                  }}
                >
                  {subItem.title}
                </a>
              </Link>
            </MenuItem>
          ))}
        </MenuList>
      </LeftMenu>
      <BannerArea
        onClick={() => {
          if (url) {
            router.push(url);
          }
        }}
        style={{ cursor: url ? "pointer" : "default" }}
      >
        {img ? (
          <img src={img} alt={title} />
        ) : (
          <img
            src="https://file.caretbio.com/caretbio/3c0efd8a1a5306490192452fb4bd6ca1.png"
            alt="기본 배너 이미지"
          />
        )}
      </BannerArea>
    </MenuWrapper>
  );
};

export default CategoryMenu;
